import { render, staticRenderFns } from "./TasinmazBilgisiForm.vue?vue&type=template&id=22f69589"
import script from "./TasinmazBilgisiForm.vue?vue&type=script&lang=ts"
export * from "./TasinmazBilgisiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports